<div class="modalContainer">

  <div class="modal-header">
    <div class="modal-title">Loan Terms
      <div class="modal-sub-title">Please enter your suggestion below.</div>
    </div>
  </div>

  <div *ngIf="!data?.suggestedTenure">
    <mat-spinner [diameter]="35" class="mat-spinner center-block"></mat-spinner>
  </div>

  <ng-container *ngIf="data?.suggestedTenure">
    <div class="modal-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="col-xs-12 col-md-4 d-flex flex-column">
          <mat-label class="text-color-light-grey">Current Loan Tenure</mat-label>
          <mat-form-field class="input-field" appearance="outline">
            <input matInput formControlName="currentTenure" class="text-color-black" placeholder="Current Loan Tenure"
              [value]="data.currentTenure">
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-md-4 d-flex flex-column">
          <mat-label class="text-color-light-grey">Current Interest Rate</mat-label>
          <mat-form-field class="input-field" appearance="outline">
            <input matInput formControlName="currentROI" placeholder="Current Interest" class="text-color-black" [value]="data.currentROI">
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-md-4 d-flex flex-column">
          <mat-label class="text-color-light-grey">Loan Amount Offered</mat-label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="loanAmount" placeholder="Loan Amount Offered" class="text-color-black" [value]="data.loanAmount">
          </mat-form-field>
        </div>

        <ng-container *ngIf="matDialogData.isBorrower;">
          <div class="col-xs-12 col-md-4 d-flex flex-column">
            <mat-label class="text-color-light-grey">Lender Loan Tenure</mat-label>
            <mat-form-field class="input-field" appearance="outline">
              <input matInput formControlName="lenderLoanTenure" class="text-color-black" placeholder="Lender Loan Tenure"
                [value]="data.lenderLoanTenure" disabled>
            </mat-form-field>
          </div>
        </ng-container>

        <ng-container *ngIf="matDialogData.isBorrower;">
          <div class="col-xs-12 col-md-4 d-flex flex-column">
            <mat-label class="text-color-light-grey">Lender Interest Rate</mat-label>
            <mat-form-field class="input-field" appearance="outline">
              <input matInput formControlName="lenderInterestRate" class="text-color-black" placeholder="Lender Interest Rate"
                [value]="data.lenderInterestRate" disabled>
            </mat-form-field>
          </div>
        </ng-container>

        <div class="col-xs-12 col-md-4 d-flex flex-column">
          <ng-container *ngIf="matDialogData.isBorrower; else counterOfferBlock">
            <mat-label class="text-color-light-grey">Counter offer for Tenure</mat-label>
          </ng-container>
          <ng-template #counterOfferBlock>
            <mat-label class="text-color-light-grey">Suggested Tenure</mat-label>
          </ng-template>
          <mat-form-field class="dropdown-field" appearance="outline" name="suggestedTenure" style="width:100%">
            <mat-select placeholder="Suggested Tenure" formControlName="suggestedTenure" required>
              <mat-option *ngFor="let tenure of data.suggestedTenure" [value]="tenure">{{ tenure }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-xs-12 col-md-4 d-flex flex-column">
          <ng-container *ngIf="matDialogData.isBorrower; else counterOfferInterestBlock">
            <mat-label class="text-color-light-grey">Counter offer for Interest Rate</mat-label>
          </ng-container>
          <ng-template #counterOfferInterestBlock>
            <mat-label class="text-color-light-grey">Suggested Rate of Interest</mat-label>
          </ng-template>

          <mat-form-field class="dropdown-field" appearance="outline" style="width:100%">
            <mat-select placeholder="Suggested Interest Rate" formControlName="suggestedROI" required>
              <mat-option *ngFor="let rate of data.suggestedROI" [value]="rate">{{ rate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-xs-12">
          <mat-label class="text-color-light-grey">Any other remark/query:</mat-label>
          <mat-form-field class="remark-field" appearance="outline" style="width:100%">
            <input matInput formControlName="remark" placeholder="Any other remark/query" />
          </mat-form-field>
        </div>

        <div class="col-xs-12 mb-5 mt-2 d-flex justify-content-center">
          <button mat-stroked-button class="primary mr-md-3" (click)="onClose()">Back</button>
          <button type="submit" mat-flat-button class="primary" [disabled]="!form.valid">Submit</button>
        </div>
      </form>
    </div>
  </ng-container>

</div>